<template>
  <main class="pa-4 wrapper">
    <h1>Full bleed</h1>
    <p>研究表明，理想的行长约为 65 个字符。在罗马字母的背景下，45 到 85 个字符之间通常被认为是可以接受的。</p>
    <p>阅读是一个复杂的过程，我们应该努力让它尽可能简单。</p>
    <img
      :src="require('@/modules/full-bleed/image.png')"
      alt="猫鼬的随机照片"
      style="max-height:60vh;object-fit:cover"
      class="full-bleed"
    >
    <p>代码:</p>
    <highlightjs
      :code="`${csscode}`"
      language="css"
    />
    <highlightjs
      class="mt-4"
      :code="`${htmlcode}`"
      language="html"
    />
    <p>CSS注释:</p>
    <highlightjs
      class="mt-2"
      :code="`${csscodewithcomment}`"
      language="css"
    />
    <h2>参考</h2>
    <p>
      <a href="https://www.joshwcomeau.com/css/full-bleed/">https://www.joshwcomeau.com/css/full-bleed/</a>
    </p>
  </main>
</template>

<script>

export default {
  data() {
    return {
      csscode: `.wrapper {
  display: grid;
  grid-template-columns:
    1fr
    min(65ch, 100%)
    1fr;
}
.wrapper > * {
  grid-column: 2;
}
.full-bleed {
  width: 100%;
  grid-column: 1 / 4;
}`,
htmlcode: `<main class="wrapper">
  <h1>Some Heading</h1>
  <p>Some content and stuff</p>
  <img class="full-bleed" alt="cute meerkat" src="/meerkat.jpg" />
</main>`,
csscodewithcomment: `/* ch是一个单位，如px或rem。它对应于0当前字体中字符的宽度，适用于指定的字体大小。我们不反向计算像素宽度，而是以字符为单位指定宽度。 */
/* 实际上，您可能仍需要做一些调整；0例如，如果您的字体有一个特别窄的字符，您就需要稍微夸大一点。 */
.wrapper {
  display: grid;
  grid-template-columns:
    1fr
    min(65ch, 100%)
    1fr;
}
/* 星号 ( * ) 是通配符；它将匹配所有类型的元素。我们说每个子元素都应分配给第二个中间列。每个新子元素都会创建一个新行 */
.wrapper > * {
  grid-column: 2;
}
/* 这个特殊的.full-bleed类允许特定的子项超出该列，并跨越所有 3 列。1 / 4是一个开始/结束语法；我们说元素应该从第 1 列（含）开始并一直跨越到第 4 列（不含） */
/* .full-bleed {
  width: 100%;
  grid-column: 1 / 4;
} */
/* 一位读者指出：我们可以通过将列分配更改为以下内容来“确保”我们的代码“面向未来”： */
.full-bleed {
  width: 100%;
  grid-column: 1 / -1;
}`,
    }
  }
}
</script>

<style scoped>
/* ch是一个单位，如px或rem。它对应于0当前字体中字符的宽度，适用于指定的字体大小。我们不反向计算像素宽度，而是以字符为单位指定宽度。 */
/* 实际上，您可能仍需要做一些调整；0例如，如果您的字体有一个特别窄的字符，您就需要稍微夸大一点。 */
.wrapper {
  display: grid;
  grid-template-columns:
    1fr
    min(65ch, 100%)
    1fr;
}
/* 星号 ( * ) 是通配符；它将匹配所有类型的元素。我们说每个子元素都应分配给第二个中间列。每个新子元素都会创建一个新行 */
.wrapper > * {
  grid-column: 2;
}
/* 这个特殊的.full-bleed类允许特定的子项超出该列，并跨越所有 3 列。1 / 4是一个开始/结束语法；我们说元素应该从第 1 列（含）开始并一直跨越到第 4 列（不含） */
/* .full-bleed {
  width: 100%;
  grid-column: 1 / 4;
} */
/* 一位读者指出：我们可以通过将列分配更改为以下内容来“确保”我们的代码“面向未来”： */
.full-bleed {
  width: 100%;
  grid-column: 1 / -1;
}

/* 移动端换行 */
a {
  word-break: break-all;
}

</style>